"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "traves": {
    "4f138884": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "926e1191": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "9c3f59af": [{
      "hkey": "ff3f34a2",
      "slug": "villa",
      "name": "Villa",
      "primary": false,
      "skipSearch": false
    }],
    "andre": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "baf265d5": [{
      "hkey": "ff3f34a2",
      "slug": "villa",
      "name": "Villa",
      "primary": false,
      "skipSearch": false
    }],
    "bertole": [{
      "hkey": "ff3f34a2",
      "slug": "villa",
      "name": "Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "traves"
    }],
    "campetto": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd3c501a": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "corgne": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d85b18be": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "f0b31af4": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "fcad797d": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "skipSearch": false
    }],
    "luisetti": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "malerba": [{
      "hkey": "ff3f34a2",
      "slug": "villa",
      "name": "Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "traves"
    }],
    "perini": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "tiglierai": [{
      "hkey": "9cfc243c",
      "slug": "traves",
      "name": "Traves",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;